import { useDispatch } from "react-redux";

import { useMount } from "app/custom-hooks/useMount";

import { syncIntegrationsThunk } from "../../store/effects/integrationSync";

export const useIntegrationsSyncCall = (): void => {
    const dispatch = useDispatch();

    useMount(() => {
        void dispatch(syncIntegrationsThunk());
    });
};
